import { useContext } from "react";

import { Burger } from "@mantine/core";

import { NavbarContext } from "@/contexts/navbar";

import classes from "./NavBarBurger.module.css";

/**
 * Opens and closes the navigation overlay on phones. The header's burger mounts as the overlay
 * closes, so it takes focus back from the overlay, whose own burger unmounts.
 */
export default function NavBarBurger() {
  const { collapsed, hasPhoneNavJustClosed, toggleCollapsed } = useContext(NavbarContext);

  return (
    <Burger
      size="sm"
      hiddenFrom="sm"
      opened={!collapsed}
      onClick={toggleCollapsed}
      aria-expanded={!collapsed}
      data-testid="navbar-burger"
      className={classes.touchTarget}
      autoFocus={hasPhoneNavJustClosed}
      aria-label={collapsed ? "Open navigation" : "Close navigation"}
    />
  );
}
